import { Injectable } from '@angular/core';
import { LoginI } from '../modelos/login.interface';
import { ResponseI } from '../modelos/response.interface';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { catchError, map, tap } from 'rxjs/operators';
import { report } from 'process';
@Injectable({
  providedIn: 'root',
})
export class AuthService {
 /*  headers: HttpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
    'Access-Control-Allow-Methods': 'POST, OPTIONS',
    'Access-Control-Allow-Credentials': 'true',
    'Access-Control-Allow-Origin': '*',
  }); */

  constructor(private http: HttpClient) {}
  private _usuario:any={
    nombre:"",
    apellidos:"",
    dni:"",
  };

  get usuario(){
    return {...this._usuario}
  }
  
  login(datos: LoginI):Observable<any> {

    /* return this.http.post<any>(`http://localhost:3000/api/v1/login`,datos); */
     return this.http.post<any>(`https://silegal-backend-master.ebinternazional.repl.co/api/v1/login`,datos);
    /* return this.http.post<any>(`https://silegal-backend-master.herokuapp.com/api/v1/login`,datos); */
    //api/v1/users/login
    
  }
  registrarUsuario(data: any): Observable<any>{
    /* return this.http.post<any>(`http://localhost:3000/api/v1/registerC`, data) */
    return this.http.post<any>(`https://silegal-backend-master.ebinternazional.repl.co/api/v1/registerC`, data) 
    /* return this.http.post<any>(`https://silegal-backend-master.herokuapp.com/api/v1/registerC`, data) */
    .pipe(
      tap(resp =>{
        if(resp.token ){

          localStorage.setItem('token', resp.token!);
         /*  this._usuario={
            
            nombres:resp.nombres,
            apellidos:resp.apellidos,
            dni:resp.dni
          
          }
          localStorage.setItem('usuario', JSON.stringify(this._usuario)); */
         
        }
      }),
      map(resp =>   resp.token),
       catchError(err => of(err.error.err[0])) 
      );
      
  }

  /* listUser() {
    let url_api = `${environment.url}`;

    return this.http
      .post(url_api, {}, { headers: this.headerSession() })
      .pipe(map((data) => data));
  } */
  //call method
  onSave(data: any) {
   // console.log(data);
    sessionStorage.setItem('token', data.data.token);
    sessionStorage.setItem('status', data.status.error);
  }

 /*  headerSession(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Methods': 'POST, OPTIONS',
      'Access-Control-Allow-Credentials': 'true',
      'Access-Control-Allow-Origin': '*',
      token: `${sessionStorage.getItem('token')}`,
    });
  } */
  isLogged(): boolean {
    let token = `${localStorage.getItem('token')}`.toString();
    if (token == '' || token == 'null') {
      return false;
    }
    return true;
  }
  cantGoBack(): boolean {
    let token = `${sessionStorage.getItem('token')}`.toString();
    if (token == '' || token == 'null') {
      return true;
    }
    return false;
  }

  logout(): void {
    localStorage.removeItem('token');
  }
}
